(function () {
    'use strict';

    // Filters

    angular
        .module('umbracoAngularFrontEnd')
        .filter('stripNonNumeric', function () {
            return function (input) {
                return input.replace(/\D/g, '');
            }
        });

    // Controller

    angular
        .module('umbracoAngularFrontEnd')
        .controller('mapController', mapController);

    mapController.$inject = ['$scope', '$http', '$timeout', 'geocodeService', 'browserGeoLocationService', 'googleMapService'];

    function mapController($scope, $http, $timeout, geocodeService, browserGeoLocationService, googleMapService) {

        $scope.$geocodeService = geocodeService; // for Geocoding addresses to lat/longs or reverse geocoding lat/longs to addresses
        $scope.$browserGeoLocationService = browserGeoLocationService; // for getting users current location
        $scope.$googleMapService = googleMapService; // for creating the map

        $scope.filteredLocations = [];
        // Create a bounding box with sides ~200 miles away from the center point. This area roughly covers the state of Arizona.
        // This makes auto-complete results more likely to be relevant. Results will not be restricted to the bounds, just more likely to appear
        $scope.defaultCoordinates = { lat: 33.69948, lng: -112.1137981 };
        $scope.defaultBounds = {
            north: $scope.defaultCoordinates.lat + 3,
            south: $scope.defaultCoordinates.lat - 3,
            east: $scope.defaultCoordinates.lng + 3,
            west: $scope.defaultCoordinates.lng - 3
        };
        $scope.coordinates = angular.copy($scope.defaultCoordinates);
        $scope.defaultCoordinatesInUse = true;
        $scope.query = '';
        $scope.isBranchLocation = false;
        $scope.isAtmLocation = false;
        $scope.isDriveUp = false;
        $scope.isFeeFreeAtmOnly = false;
        $scope.showMapAndHideList = false;
        $scope.allLocations = [];
        $scope.isLargeScreen = true;
        $scope.locationsScrollHandlerTicking = false;
        $scope.focusedLocation = null;
        $scope.intersectingLocations = [];
        $scope.intersectionObserver = null;
        $scope.locationsLoading = true;
        $scope.showVirtualLocation = false;
        $scope.filterRadius = 80;
        $scope.virtualTeamDistance = -1;
        $scope.isMapInitialized = false;

        // Operating on the google map while it is hidden can result in unexpected results.
        // Most frequently, the map will zoom out as far as possible.
        // Queue map actions here and the map actions will be triggered when the map is revealed
        $scope.pendingMapActions = [];

        $scope.initialize = function () {

            // retrieve filterRadius
            var mapContainer = document.querySelector('.map-filter-container');
            var filterRadius = mapContainer && mapContainer.attributes['data-filter-radius'] ? parseInt(document.querySelector('.map-filter-container[data-filter-radius]').attributes['data-filter-radius'].value) : -1;
            if (filterRadius) {
                $scope.filterRadius = filterRadius;
            }
            var virtualTeamDistance = mapContainer && mapContainer.attributes['data-v-team-dist'] ? parseInt(document.querySelector('.map-filter-container[data-v-team-dist]').attributes['data-v-team-dist'].value) : -1;
            if (virtualTeamDistance) {
                $scope.virtualTeamDistance = virtualTeamDistance;
            }

            // Determine screen size and watch for changes (e.g. device rotation, browser window resize)
            var mqlLargeScreen = window.matchMedia('(min-width: 1024px)');
            var onTransitionToLargeScreen = function (event) {
                if (event.matches) {
                    $scope.isLargeScreen = true;
                    //console.log('[mqlLargeScreenChange] $scope.isLargeScreen: %o', $scope.isLargeScreen);
                    $scope.$googleMapService.closeInfoWindow();
                    $scope.$digest();
                } else {
                    $scope.isLargeScreen = false;
                    //console.log('[mqlLargeScreenChange] $scope.isLargeScreen: %o', $scope.isLargeScreen);
                    $scope.$digest();

                }
                $scope.reloadIntersectionObserver();
            };

            if (mqlLargeScreen.addEventListener) {
                mqlLargeScreen.addEventListener('change', onTransitionToLargeScreen);
            }
            else if (mqlLargeScreen.addListener) {
                // for backwards compatibility
                mqlLargeScreen.addListener(onTransitionToLargeScreen);
            }

            $scope.isLargeScreen = mqlLargeScreen.matches;
            //console.log('[initialize] $scope.isLargeScreen: %o', $scope.isLargeScreen);

            // Determine locations in list that are currently scrolled into view
            $scope.intersectionObserver = new IntersectionObserver(function (entries) {
                entries.forEach(function (entry) {
                    var index = parseInt(entry.target.getAttribute("data-index"));
                    if (entry.isIntersecting) {
                        $scope.intersectingLocations.push(index);
                    } else {
                        $scope.intersectingLocations = $scope.intersectingLocations.filter(function (item) { return item != index; });
                    }
                });

                $scope.focusedLocation = $scope.intersectingLocations.sort(function (a, b) { return a - b; })[0];
                $scope.$digest();

                if ($scope.defaultCoordinatesInUse && $scope.isLargeScreen) {
                    $scope.pendingMapActions = [];
                    $scope.pendingMapActions.push($scope.$googleMapService.panToMarkerAtIndex.bind(this, $scope.focusedLocation));
                } else if ($scope.isLargeScreen) {
                    $scope.pendingMapActions = [];
                    $scope.pendingMapActions.push($scope.$googleMapService.setActiveMarkerAtIndex.bind(this, $scope.focusedLocation));
                }

                if ($scope.isMapVisible()) {
                    $scope.executeQueuedMapActions();
                }

                //console.log("[intersectionObserver] $scope.focusedLocation: %o", $scope.focusedLocation);
                //console.log("[intersectionObserver] $scope.intersectingLocations: %o", $scope.intersectingLocations);
            }, {
                root: document.getElementById("scrollingLocationsSection"),
                rootMargin: "-8px 0px 60px 0px",
                threshold: 0.5
            });

            // Initialize the map
            if ($scope.isMapVisible()) {
                $scope.executeQueuedMapActions();
            }

            $scope.initializeAutoComplete();

            // Load all locations
            $http.get("/umbraco/api/findlocationsApi/GetAll").then(function (results) {
                //console.log('[getLocations] %o', results);
                $scope.allLocations = angular.copy(results.data);
                $scope.getDeviceLocation();
            });
        }

        // don't initialize the map until the map div container actually has a size
        // otherwise, the zoom and map bounds are all messed up
        $scope.initializeMap = function () {
            $scope.$googleMapService.initMap($scope.defaultCoordinates, 8);
            $scope.isMapInitialized = true;
        }

        $scope.initializeAutoComplete = function () {
            const options = {
                bounds: $scope.defaultBounds,
                componentRestrictions: { country: "us" }, // Only search for US addresses
                fields: ["geometry"], // Just return the lat/long
                strictBounds: false, // Also search outside the bounds
                types: ["geocode"], // Address/city/state/zip results only
            };
            const searchBoxInput = document.getElementById("search-box");
            const googleAutocomplete = new google.maps.places.Autocomplete(searchBoxInput, options);
            google.maps.event.addListener(googleAutocomplete, 'place_changed', function () {
                const place = googleAutocomplete.getPlace();

                $scope.defaultCoordinatesInUse = !place || !place.geometry || !place.geometry.location;
                $scope.coordinates.lat = $scope.defaultCoordinatesInUse ? $scope.defaultCoordinates.lat : place.geometry.location.lat();
                $scope.coordinates.lng = $scope.defaultCoordinatesInUse ? $scope.defaultCoordinates.lng : place.geometry.location.lng();

                $scope.query = document.getElementById("search-box").value; // Angular doesn't pick up the change without this
                //console.log("[googleAutocomplete->place_changed] $scope.coordinates: %o", $scope.coordinates);
                $scope.search();

                if ($scope.isMapVisible()) {
                    $scope.executeQueuedMapActions();
                }
            });
        }

        $scope.executeQueuedMapActions = function () {
            if (!$scope.isMapInitialized) {
                $scope.initializeMap();
            }
            for (var i = 0; i < $scope.pendingMapActions.length; i++) {
                var mapAction = $scope.pendingMapActions[i];
                if (mapAction instanceof Function) {
                    mapAction();
                }
            }

            $scope.pendingMapActions = [];
        }

        $scope.getDeviceLocation = function () {
            $scope.$browserGeoLocationService.getLocation()
                .then(function (data) {
                    //console.log("[getCurrentLocation->browserGeoLocationService] %o", data);
                    $scope.defaultCoordinatesInUse = !data || !data.coords;
                    $scope.coordinates.lat = $scope.defaultCoordinatesInUse ? $scope.defaultCoordinates.lat : data.coords.latitude;
                    $scope.coordinates.lng = $scope.defaultCoordinatesInUse ? $scope.defaultCoordinates.lng : data.coords.longitude;
                    $scope.defaultCoordinatesInUse = false;
                    //console.log("[getCurrentLocation] $scope.coordinates: %o", $scope.coordinates);
                    $scope.$geocodeService.reverseAddress($scope.coordinates.lat, $scope.coordinates.lng).then(function (response) {
                        //console.log("[getCurrentLocation->reverseAddress] %o", response);
                        $scope.query = response.formattedAddress;
                        $scope.search();

                        if ($scope.isMapVisible()) {
                            $scope.executeQueuedMapActions();
                        }
                    });
                })
                .catch(function (error) {
                    $scope.search();
                });
        }

        $scope.isMapVisible = function () {
            return $scope.isLargeScreen || $scope.showMapAndHideList;
        }

        function convertMilesToMeters(miles) {
            return miles * 0.00062137;
        }

        $scope.clearSearch = function () {
            $scope.query = '';
            $scope.coordinates = angular.copy($scope.defaultCoordinates);
            $scope.defaultCoordinatesInUse = true;
            $scope.search();
        }

        $scope.searchWithRawAddressText = function () {
            //console.log("[searchWithRawAddressText] $scope.query: %o", $scope.query);

            if ($scope.query.length > 0) {
                $scope.$geocodeService.geocode($scope.query).then(function (result) {
                    $scope.coordinates.lat = result.latitude;
                    $scope.coordinates.lng = result.longitude;
                    $scope.defaultCoordinatesInUse = false;
                    //console.log("[searchWithRawAddressText->geocode] $scope.coordinates: %o", $scope.coordinates);
                    $scope.search();
                });
            } else {
                $scope.clearSearch();
            }
        }

        $scope.search = function () {
            $scope.filteredLocations = [];
            $scope.filteredLocations.length = 0;
            //console.log("[search] $scope.coordinates: %o", $scope.coordinates);
            //console.log("[search] $scope.defaultCoordinatesInUse: %o", $scope.defaultCoordinatesInUse);

            var closestLocation;
            for (var i = 0; i < $scope.allLocations.length; i++) {
                var location = $scope.allLocations[i];
                var isMatch = false;

                // Apply filters
                if (!$scope.isBranchLocation && !$scope.isAtmLocation && !$scope.isDriveUp && !$scope.isFeeFreeAtmOnly) {
                    isMatch = true;
                }
                else {
                    if ($scope.isBranchLocation && location.isBranchLocation) { isMatch = true; }
                    if ($scope.isAtmLocation && (location.isAtmLocation || location.isFeeFreeAtm || location.isCoinstar)) { isMatch = true; }
                    if ($scope.isDriveUp && location.isDriveUp) { isMatch = true; }
                    if ($scope.isFeeFreeAtmOnly && location.isFeeFreeAtm) { isMatch = true; }
                }

                if (!isMatch) { continue; }

                // Get distances
                location.distanceFromUser = Math.ceil(convertMilesToMeters(google.maps.geometry.spherical.computeDistanceBetween(
                    { lat: location.latitude, lng: location.longitude },
                    $scope.coordinates
                )));

                if (!closestLocation || location.distanceFromUser < closestLocation.distanceFromUser) {
                    closestLocation = location;
                }

                if ($scope.defaultCoordinatesInUse || location.distanceFromUser <= $scope.filterRadius) {
                    $scope.filteredLocations.push(location);
                }
            }

            // if no locations in range, keep the closest location that matched the filter params
            if ($scope.filteredLocations.length === 0) {
                $scope.filteredLocations.push(closestLocation);
            }

            $scope.filteredLocations.sort(
                function compare(a, b) {
                    if (a.distanceFromUser > b.distanceFromUser) { return 1; }
                    if (a.distanceFromUser < b.distanceFromUser) { return -1; }
                    return 0;
                });

            for (var i = 0; i < $scope.filteredLocations.length; i++) {
                $scope.filteredLocations[i].distanceRank = i + 1;
                // Approximate the real road travel distance (* 1.25)
                $scope.filteredLocations[i].distanceFromUser = Math.ceil($scope.filteredLocations[i].distanceFromUser * 1.25);
            }

            // If the closest location is far away, show a virtual location card
            if ($scope.virtualTeamDistance >= 0 && !$scope.defaultCoordinatesInUse && $scope.filteredLocations[0].distanceFromUser > $scope.virtualTeamDistance) {
                $scope.showVirtualLocation = true;
            }

            //console.log("[search] $scope.filteredLocations: %o", $scope.filteredLocations);

            // wipe all other pending map actions, what we do here with the search makes any prior map actions invalid
            $scope.pendingMapActions = [];
            $scope.pendingMapActions.push($scope.$googleMapService.setBankLocations.bind(this, $scope.filteredLocations));
            $scope.pendingMapActions.push($scope.$googleMapService.drop);

            if (!$scope.defaultCoordinatesInUse) {
                $scope.pendingMapActions.push($scope.$googleMapService.panToMarkerAtIndex.bind(this, 0, 11, true));
            } else {
                // put a slight delay on resetBounds. If this occurs before the map is visible, it could result in full zoom out of whole world
                $scope.pendingMapActions.push($timeout.bind(this, $scope.$googleMapService.resetBounds, 100));
            }

            $scope.pendingMapActions.push($scope.resetListViewScroll);

            if ($scope.isMapVisible()) {
                $scope.executeQueuedMapActions();
            }

            $scope.locationsLoading = false;

            $scope.pendingMapActions.push($timeout($scope.reloadIntersectionObserver, 100));
        }

        $scope.reloadIntersectionObserver = function () {
            $scope.intersectionObserver.disconnect();
            if ($scope.isLargeScreen) {
                //console.log("[reloadIntersectionObserver]");
                $scope.intersectingLocations = [];
                document.querySelectorAll("#scrollingLocationsSection .location").forEach(function (location) {
                    $scope.intersectionObserver.observe(location);
                });
            }
        }

        $scope.resetListViewScroll = function () {
            document.getElementById('scrollingLocationsSection').scrollTo(0, 0);
        }

        $scope.showMapAndHideListToggle = function (value) {
            $scope.showMapAndHideList = value;
            if ($scope.showMapAndHideList) {
                $scope.executeQueuedMapActions();
            }
        }

        $scope.focusLocation = function ($event) {
            if ($scope.isLargeScreen) {
                var selectedLocation = $event.currentTarget;
                var hasFocus = selectedLocation.classList.contains('focus');
                if (!hasFocus) {
                    $scope.$googleMapService.handleLocationSelect(selectedLocation);
                }
            }
        }

        $scope.initialize();
    }
})();